module.exports = __webpack_public_path__ + "static/media/icon_fechar_BLACK.f2187d4f.svg";